export const ANALYTICS_CANCEL_DELETING_ACCOUNT =
  'delete-direct-deposit/ANALYTICS_CANCEL_DELETING_ACCOUNT';
